module.exports = __webpack_public_path__ + "static/media/nervous-system-diseases-icon.42632dea.svg";